import moment from "moment";
import clevertap from "clevertap-web-sdk";
import { useContext, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { DatePicker } from "react-responsive-calendar-picker";
import "react-responsive-calendar-picker/dist/index.css";
import { useLocation, useSearchParams } from "react-router-dom";

//assets
import { SvgCalendar as Calendar } from "assets/icons/js/SvgCalendar";
import SvgDownArrowGrey from "assets/icons/js/SvgDownArrowGrey";
import { SvgGuest as Guest } from "assets/icons/js/SvgGuest";
import { SvgRedExclamtion } from "assets/icons/js/SvgRedExclamtion";
import SvgStarFilledBlue from "assets/icons/js/SvgStarFilledBlue";
// import { SvgUnlockDiscount } from "assets/icons/js/SvgUnlockDiscount";
import { SvgInfo } from "assets/icons/js/SvgInfo";
import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";
import SvgUpArrowGrey from "assets/icons/js/SvgUpArrowGrey";
import { ReactComponent as Loader } from "assets/spinning_wheel.svg";
import { ReactComponent as Convenience } from "assets/icons/Convenience.svg";
// context
import { ListingInterface } from "context/ListingData";

//helpers
import addCommas from "helpers/addCommasToNumber";
import { axiosInstance } from "helpers/axiosInstance";
import { formatDate } from "helpers/dateFormatter";
import { sameDayCheckin } from "helpers/sameDayCheckin";

//components
import GuestPopUp from "components/Home/SearchBar/GuestPopUp";
import { LeadForm } from "components/LeadForm";
import Modal from "components/LoginAndRegister/Modal";
import { ListingCoupon } from "../ListingCoupon";
import { ListingTimer } from "../ListingTimer";
import ListingWeekDayOffer from "../ListingWeekdayOffer";
import { UnlockDiscount } from "../UnlockDiscount";
import { Bookingfeature } from "./BookingFeature";
import { NewHomeOffer } from "./NewHomeOffer";
import { ReactComponent as CouponSvg } from "assets/coupon.svg";
import { ReactComponent as TaStars } from "./assets/taStars.svg";
// styles
import ListingWeekDayOfferGst from "../ListingWeekdayOfferGst";
import "./style.scss";
import { UserContext } from "store";
import { Tooltip } from "react-tooltip";
import { renderToString } from "react-dom/server";
import { useCheckSavePrice } from "helpers/useCheckSavePrice";
import { useListingCalculations } from "customHooks/useListingCalculations";
import { FinishPhoneSignup } from "components/LoginAndRegister/FinishPhoneSignup";
import AskHelp, { AskMeModal } from "components/Booking/AskHelp";
import { useTheme } from "components/ListingNew/ListingTheme";
import ListingPdf from "../ListingPdf";
import { WeeklyOfferChecker } from "helpers/checkWeekendOffer";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import PhoneLoginHandler from "components/LoginAndRegister/PhoneLoginHandler";
import EmailLoginHandler from "components/LoginAndRegister/EmailLoginHandler";
import { ReactComponent as HighTAC } from "assets/HighTAC.svg";
const BookingBox = ({
	id,
	dates,
	setDates,
	mealRequired = false,
	discount = 0,
	pricePerNight = 0,
	rating = 0,
	calculations = {},
	calError = false,
	calLoading = false,
	onCreateBooking = () => {},
	blocked,
	sameDay,
	spl,
	storedDates,
	sortArrVal,
	bestVal,
	newCalculations,
	newDates,
	dis,
	prevCalculations,
	review = 0,
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [isShown, setIsShown] = useState(false);
	// query parametrs
	const useSearchQuery = () => {
		const { search } = useLocation();
		return useMemo(() => new URLSearchParams(search), [search]);
	};

	let query = useSearchQuery();

	const {
		childrenData,
		adultsData,
		roomsData,
		data,
		setChildrenData,
		setAdultsData,
		setRoomsData,
		setInfantsData,
		infantsData,
		petData,
		setPetData,
		showPet,
		petCharge,
		isFromGoogle,
	} = useContext(ListingInterface);
	const listingList = data?.data?.listing_list;
	const isNext = false;

	const [openDatePicker, setOpenDatePicker] = useState(false);
	const [openGuest, setOpenGuest] = useState(false);

	const [showLeadFormModal, setShowLeadFormModal] = useState(false);

	const closeLeadFormModal = () => {
		setShowLeadFormModal(false);
	};

	useEffect(() => {
		if (dates.checkin && dates.checkout) setOpenDatePicker(false);
	}, [dates.checkin, dates.checkout]);

	useEffect(() => {
		if (dates.checkin) {
			searchParams.set("checkin", moment(dates.checkin).format("YYYY-MM-DD"));
			setSearchParams(searchParams);
		}
		if (dates.checkout) {
			searchParams.set("checkout", moment(dates.checkout).format("YYYY-MM-DD"));
			setSearchParams(searchParams);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dates.checkin, dates.checkout]);

	const dynamicPricePerNight =
		Object.keys(calculations).length > 0
			? (calculations.ROOM_CHARGES +
					calculations.meal_total +
					calculations.EXTRA_CHARGES) /
			  calculations.numNights
			: listingList?.per_night_charge;

	const location = window.location.pathname.split("/")[2].split("-");
	const newId = location[location.length - 1];

	const checkDiffIn = moment(dates.checkin);
	const checkDiffOut = moment(dates.checkout);
	const dateDiff = Math.abs(checkDiffIn.diff(checkDiffOut, "days"));

	let key,
		keys = Object.keys(listingList);
	let n = keys.length;
	let typeData = {};
	while (n--) {
		key = keys[n];
		if (key === "no_of_beds") {
			typeData["NO_OF_BEDROOMS"] = listingList[key];
		} else {
			typeData[key.toUpperCase()] = listingList[key];
		}
	}

	const { dispatch } = useContext(UserContext);

	const [anchorId, setAnchorId] = useState(Math.floor(Math.random() * 10000));

	const [askOpen, setAskOpen] = useState(false);
	const [roomOffer, setRoomOffer] = useState(false);
	const [shouldShowModal, setShouldShowModal] = useState(false);
	const [phone, setPhone] = useState(true);
	useEffect(() => {
		setAnchorId(Math.floor(Math.random() * 10000));
		searchParams.set("coupon", calculations?.coupon_code || "");
		setSearchParams(searchParams);
	}, [calculations]);

	const theme = useTheme();

	const { state } = useContext(UserContext);
	const { currentUser } = state;

	const b2bLeadCreation = async () => {
		const payload = {
			GUEST_NAME: currentUser?.firstName + currentUser?.lastName,
			GUEST_EMAIL: currentUser?.email,
			GUEST_NUMBER: currentUser?.mobile,
			GUEST_PINCODE: currentUser?.pincode,
			BUDGET_HIGH: data?.data?.listing_list?.per_night_charge,
			TYPE: "Vacation",
			VILLAS_IN_MIND: [data?.data?.listing_list?.id],
			DATE_FLEXIBLE: "E",
			MEDIUM: "Website - Travel Agent",
			SOURCE: "Website",
		};
		const res = await axios.post(
			"https://ecapi.saffronstays.com/create-lead",
			payload,
		);
		if (res?.data?.success) {
			toast.success(`Requested Successfully`, {
				position: window.innerWidth < 800 ? "top-right" : "bottom-right",
				autoClose: 3000,
				hideProgressBar: false,
				icon: true,
				closeOnClick: false,
				pauseOnHover: false,
				draggable: false,
				progress: undefined,
			});
		}
	};

	return (
		<>
			<div className="booking-box-container">
				<div
					className="booking-box"
					style={{
						background: theme?.background2,
						border: theme?.borderBookingBox,
						boxShadow: theme?.name === "xseries" && "none",
					}}
				>
					{/* {theme?.name === "xseries" && (
						<div className="price-rating">
							<div className="price" style={{ color: theme?.primaryTextColor }}>
								<h2
									className="sub-heading"
									style={{ color: theme?.primaryTextColor }}
								>
									Starting ₹{addCommas(listingList?.per_night_charge)} <br />
								</h2>
							</div>
							{rating ? (
								<div className="rating ">
									<SvgStarFilledBlue
										fill={theme?.name === "xseries" && theme.starColor}
									/>
									<div
										className="text-sm-bold"
										style={{ color: theme?.primaryTextColor }}
									>
										{rating?.toFixed(1)} {review && `(${review})`}
									</div>
								</div>
							) : null}
						</div>
					)} */}
					{
						// theme?.name !== "xseries" &&
						!isFromGoogle &&
						listingList?.unlock_magic === "N" &&
						listingList.classification ? (
							<>
								<div className="price-rating">
									<div
										className="price"
										style={{ color: theme?.primaryTextColor }}
									>
										{Object.keys(calculations).length === 0 ? (
											<>
												{dis - dynamicPricePerNight > 0 ||
												calculations.TOTAL_AMOUNT_WITH_SERVICE -
													calculations.ROOM_CHARGES >
													0 ? (
													<div className="text-xsm-light clr-grey line-through">
														₹
														{addCommas(
															calculations.TOTAL_AMOUNT_WITH_SERVICE
																? calculations.TOTAL_AMOUNT_WITH_SERVICE
																: dis,
														)}
													</div>
												) : null}
												<h2
													className="sub-heading"
													style={{ color: theme?.primaryTextColor }}
												>
													{calculations?.ROOM_CHARGES
														? `₹ ${addCommas(calculations.ROOM_CHARGES)}`
														: `Starting ₹ ${addCommas(
																dynamicPricePerNight,
														  )}`}{" "}
													<span
														className="text-12px-light font-heading"
														style={{ color: theme?.primaryTextColor }}
													>
														{calculations?.booking_fee_tax &&
														listingList.min_rooms
															? "+ " +
															  addCommas(calculations?.booking_fee_tax) +
															  " (GST)"
															: `/ night`}
													</span>
													<br />
													<span
														className="text-12px-light font-heading"
														style={{
															display: "block",
															marginLeft: 0,
															textAlign: "left",
															color: theme?.primaryTextColor,
														}}
													>
														{" "}
														{calculations?.booking_fee_tax &&
														listingList.min_rooms
															? ""
															: listingList.TYPE_FLAG !== "MR" &&
															  listingList.min_rooms > 1 &&
															  `(${(
																	dynamicPricePerNight / listingList.min_rooms
															  )?.toLocaleString("en-IN", {
																	currency: "INR",
																	style: "currency",
															  })} x ${listingList.min_rooms} Rooms)`}
													</span>
												</h2>
											</>
										) : (
											<>
												{dis - dynamicPricePerNight > 0 ||
												calculations.TOTAL_AMOUNT_WITH_SERVICE -
													calculations.ROOM_CHARGES >
													0 ? (
													<div className="text-xsm-light clr-grey line-through">
														₹
														{addCommas(
															calculations.TOTAL_AMOUNT_WITH_SERVICE
																? calculations.TOTAL_AMOUNT_WITH_SERVICE
																: dis,
														)}
													</div>
												) : null}
												<h2
													className="sub-heading"
													style={{ color: theme?.primaryTextColor }}
												>
													{calculations?.total_amount_with_discount
														? `₹ ${addCommas(
																calculations.total_amount_with_discount,
														  )}`
														: `Starting ₹ ${addCommas(
																dynamicPricePerNight,
														  )}`}{" "}
													<span className="text-12px-light clr-black font-heading">
														{calculations?.BOOKING_FEE_SERVICE_TAX_AMOUNT &&
														listingList.min_rooms
															? ""
															: "/ night"}
													</span>
												</h2>
											</>
										)}
									</div>
									{rating ? (
										<div className="rating-wrapper">
											{currentUser?.isTravelAgent && listingList?.high_tac && (
												<HighTAC />
											)}
											<div className="rating">
												<SvgStarFilledBlue />
												<div
													className="text-sm-bold"
													style={{ color: theme?.primaryTextColor }}
												>
													{rating?.toFixed(1)} {review && `(${review})`}
												</div>
											</div>
										</div>
									) : null}
								</div>
								{/* <hr /> */}
							</>
						) : null
					}
					{!isFromGoogle && listingList?.classification === 0 ? (
						<>
							<div className="price-rating">
								<div
									className="price"
									style={{ color: theme?.primaryTextColor }}
								>
									{!calculations?.discount_amount ? (
										<>
											{dis - dynamicPricePerNight > 0 ||
											calculations.TOTAL_AMOUNT_WITH_SERVICE -
												calculations.ROOM_CHARGES >
												0 ? (
												<div className="text-xsm-light clr-grey line-through">
													₹
													{addCommas(
														listingList.TYPE_FLAG === "MR" ||
															listingList.TYPE_FLAG === "MV"
															? Math.round(
																	calculations.TOTAL_AMOUNT_WITH_SERVICE
																		? (calculations.TOTAL_AMOUNT_WITH_SERVICE *
																				roomsData) /
																				(childrenData + adultsData)
																		: dis,
															  )
															: Math.round(
																	calculations.TOTAL_AMOUNT_WITH_SERVICE
																		? calculations.TOTAL_AMOUNT_WITH_SERVICE /
																				(childrenData + adultsData)
																		: dis,
															  ),
													)}
												</div>
											) : null}
											<h2
												className="sub-heading"
												style={{ color: theme?.primaryTextColor }}
											>
												{calculations?.ROOM_CHARGES
													? `₹ ${addCommas(
															listingList.TYPE_FLAG === "MR" ||
																listingList.TYPE_FLAG === "MV"
																? Math.round(
																		(calculations?.ROOM_CHARGES * roomsData) /
																			(childrenData + adultsData),
																  )
																: Math.round(
																		calculations?.ROOM_CHARGES /
																			(childrenData + adultsData),
																  ),
													  )}`
													: `Starting ₹ ${addCommas(
															listingList.TYPE_FLAG === "MR" ||
																listingList.TYPE_FLAG === "MV"
																? Math.round(
																		(dynamicPricePerNight * roomsData) /
																			(childrenData + adultsData),
																  )
																: Math.round(
																		dynamicPricePerNight /
																			(childrenData + adultsData),
																  ),
													  )}`}{" "}
												<span className="text-12px-light clr-black font-heading">
													{calculations?.BOOKING_FEE_SERVICE_TAX_AMOUNT &&
													listingList.min_rooms
														? "/ person + " +
														  addCommas(
																calculations?.BOOKING_FEE_SERVICE_TAX_AMOUNT,
														  ) +
														  " (GST)"
														: "/ person"}
												</span>
											</h2>
										</>
									) : (
										<>
											{dis - dynamicPricePerNight > 0 ||
											calculations.TOTAL_AMOUNT_WITH_SERVICE -
												calculations.ROOM_CHARGES >
												0 ? (
												<div
													className="text-xsm-light line-through"
													style={{ color: theme?.secondaryTextColor }}
												>
													₹
													{addCommas(
														Math.round(
															calculations.TOTAL_AMOUNT_WITH_SERVICE
																? calculations.TOTAL_AMOUNT_WITH_SERVICE /
																		(childrenData + adultsData)
																: dis,
														),
													)}
												</div>
											) : null}
											<h2
												className="sub-heading"
												style={{ color: theme?.primaryTextColor }}
											>
												{calculations?.total_amount_with_discount
													? `₹ ${addCommas(
															Math.round(
																calculations.total_amount_with_discount /
																	(childrenData + adultsData),
															),
													  )}`
													: `Starting ₹ ${addCommas(
															Math.round(
																dynamicPricePerNight /
																	(childrenData + adultsData),
															),
													  )}`}{" "}
												<span
													className="text-12px-light font-heading"
													style={{ color: theme?.primaryTextColor }}
												>
													{calculations?.booking_fee_tax &&
													listingList.min_rooms
														? "/ person"
														: "/ person"}
												</span>
											</h2>
										</>
									)}
								</div>
								{rating ? (
									<div className="rating ">
										<SvgStarFilledBlue />
										<div
											className="text-sm-bold"
											style={{ color: theme?.primaryTextColor }}
										>
											{rating?.toFixed(1)} {review && `(${review})`}
										</div>
									</div>
								) : null}
							</div>
							<hr />
						</>
					) : null}
					{calError && (
						<div className=" booking-box__error">
							<SvgRedExclamtion />
							<p className="text-xsm-light error">
								{calError === "rooms not avaiable for given dates" &&
									`This home is not available for the selected dates. Please change them to see availability.`}
								{calError === "minimum nights for this listing are 2" &&
									`Minimum nights for this listing are two. Please change the dates.`}
								{calError === "minimum nights for this listing are 3" &&
									`Minimum nights for this listing are three. Please change the dates.`}
								{![
									"rooms not avaiable for given dates",
									"minimum nights for this listing are 2",
									"minimum nights for this listing are 3",
								].includes(calError) && calError}
							</p>
						</div>
					)}
					{/* {calError &&
					(calError === "rooms not avaiable for given dates" ||
						calError === "minimum nights for this listing are 2" ||
						calError === "minimum nights for this listing are 3") ? (
						<div className=" booking-box__error">
							<SvgRedExclamtion />
							{calError === "rooms not avaiable for given dates" && (
								<p className="text-xsm-light error">
									This home is not available for the selected dates. Please
									change them to see availability.
								</p>
							)}
							{calError === "minimum nights for this listing are 2" && (
								<p className="text-xsm-light error">
									Minimum nights for this listing are two. Please change the
									dates.
								</p>
							)}
							{calError === "minimum nights for this listing are 3" && (
								<p className="text-xsm-light error">
									Minimum nights for this listing are three. Please change the
									dates.
								</p>
							)}
						</div>
					) : null} */}

					{listingList.participating_rewards_program !== "N" ? (
						<UnlockDiscount
							price={
								calculations.ROOM_CHARGES
									? calculations.ROOM_CHARGES
									: dynamicPricePerNight
							}
							id={id ? id : newId}
							theme={theme}
						/>
					) : null}
					{
						// theme?.name !== "xseries" &&
						!dates.checkin && !dates.checkout && (
							<span className="dates-nudge-wrapper">
								<CouponSvg /> Add dates for best price
							</span>
						)
					}
					{listingList?.unlock_magic === "N" || theme?.name === "xseries" ? (
						<>
							<div className={`filters`}>
								<DatePicker
									dates={dates}
									open={openDatePicker}
									setOpen={setOpenDatePicker}
									setDates={setDates}
									blocked={blocked}
									sameDay={sameDayCheckin(sameDay) ? 1 : 0}
									style={{
										zIndex: "10",
										top: "150px",
										right: "-20px",
									}}
									spl={spl}
									detail={storedDates}
								>
									<div
										className="search-elements dates"
										onClick={() => {
											setOpenDatePicker(true);
										}}
									>
										<Calendar color={theme?.iconColor} width="20" />
										<div className="dates-input-wrapper">
											<input
												autoComplete="off"
												required
												type="text"
												name="checkin"
												id="dates-checkin-input"
												className="text-xsm-light"
												value={dates.checkin && formatDate(dates.checkin)}
												style={{
													background: theme.background2,
													color: theme.primaryTextColor,
												}}
												onChange={() => {}}
											/>
											<label
												className="text-xsm-light"
												style={{
													color: theme.baseTextColor,
												}}
											>
												Check in
											</label>
										</div>
										<span className="dash-span">{"-"}</span>
										<div className="dates-input-wrapper">
											<input
												autoComplete="off"
												required
												type="text"
												name="checkout"
												id="dates-checkout-input"
												className="text-xsm-light"
												value={dates.checkout && formatDate(dates.checkout)}
												onChange={() => {}}
												style={{
													background: theme.background2,
													color: theme.primaryTextColor,
												}}
												onClick={() => {
													setDates({
														...dates,
														checkout: "",
													});
												}}
											/>
											<label
												className="text-xsm-light"
												style={{
													color: theme.baseTextColor,
												}}
											>
												Check out
											</label>
										</div>
									</div>
									<div className="date-select">
										<SvgUpArrowGrey />
										<SvgDownArrowGrey />
									</div>
								</DatePicker>

								<div className="search-elements guests">
									<Guest color={theme?.iconColor} />
									<div
										className="guests-input-wrapper"
										onClick={() => setOpenGuest((prev) => !prev)}
									>
										<span
											style={{
												color: theme.primaryTextColor,
											}}
										>
											{adultsData + childrenData} Guests{" "}
											{listingList?.TYPE_FLAG === "MV"
												? "- " + roomsData
												: listingList?.TYPE_FLAG === "EV"
												? ""
												: "- " + roomsData}
											{listingList?.TYPE_FLAG === "MV"
												? " Villa"
												: listingList?.TYPE_FLAG === "EV"
												? ""
												: " Rooms"}
										</span>
										<div className="room-select">
											<SvgUpArrowGrey />
											<SvgDownArrowGrey />
										</div>
									</div>
									<GuestPopUp
										open={openGuest}
										query={query}
										setOpen={setOpenGuest}
										typeData={typeData}
										infantsData={infantsData}
										childrenData={childrenData}
										adultsData={adultsData}
										roomsData={roomsData}
										setAdultsData={setAdultsData}
										setChildrenData={setChildrenData}
										setInfantsData={setInfantsData}
										setRoomsData={setRoomsData}
										showPet={showPet}
										setPetData={setPetData}
										petData={petData}
										petCharge={petCharge}
									></GuestPopUp>
								</div>
							</div>
							{/* {Object.keys(calculations).length > 0 && (
								<div className="calculations ">
									<div className="con-space-between">
										<div className="text-xsm-light clr-grey">Room Charges</div>
										<div className="text-xsm clr-black">
											₹{addCommas(calculations.room_charge)}
										</div>
									</div>
									{calculations.meal_total ? (
										<div className="con-space-between">
											<div className="text-xsm-light clr-grey">Meals</div>
											<div className="text-xsm clr-black">
												₹{addCommas(calculations.meal_total)}
											</div>
										</div>
									) : null}
									{(calculations.extra_charges !== 0 ||
										calculations.total_big_child_charges !== 0) && (
										<div className="con-space-between">
											<div>
												<p className="text-xsm-light clr-grey">
													Extra Guest Charges
												</p>
												<span
													onMouseEnter={() => setIsShown(true)}
													onMouseLeave={() => setIsShown(false)}
													className="info-icon"
												>
													<SvgInfo />
													{isShown && (
														<div className="info-div">
															{`Any booking above ${
																listingList.min_rooms * 2
															} guest will be charged as extra guest.`}
														</div>
													)}
												</span>
											</div>
											<div className="text-xsm clr-black">
												₹
												{addCommas(
													calculations.extra_charges +
														calculations.total_big_child_charges,
												)}
											</div>
										</div>
									)}
									<div className="con-space-between">
										<div className="text-xsm-light clr-grey">GST</div>
										<div className="text-xsm clr-black">
											₹{addCommas(calculations.booking_fee_tax)}
										</div>
									</div>
									{mealRequired && (
										<div className="con-space-between">
											<div className="text-xsm-light clr-grey">GST Meals</div>
											<div className="text-xsm clr-black">
												₹{addCommas(calculations.service_tax_meal)}
											</div>
										</div>
									)}
								</div>
							)} */}

							{theme.name !== "xseries" &&
								Object.keys(calculations).length > 0 && (
									<>
										<div
											className="con-space-between"
											style={{
												marginTop: "20px",
												display: "flex",
												alignItems: "center",
												marginBottom: calculations?.discount_amount && "20px",
											}}
										>
											<div
												className="text-sm-light"
												style={{ color: theme.primaryTextColor }}
											>
												Total Price
											</div>
											<div
												className="text-sm-bold"
												id={"price-tooltip" + anchorId}
												data-tooltip-html={PriceTool({
													calculations: calculations,
													setIsShown: setIsShown,
													mealRequired: mealRequired,
													isShown: isShown,
													listingList: listingList,
												})}
											>
												{!isFromGoogle && (
													<Tooltip
														delayHide={100}
														events={["hover"]}
														anchorId={"price-tooltip" + anchorId}
														style={{
															pointerEvents: "auto",
															border: "1px solid #F4F7FE",
															opacity: 1,
															boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.15)",
															padding: "20px",
															zIndex: "100",
															...theme.pricePopUp,
														}}
													/>
												)}
												<u
													style={{
														cursor: "pointer",
														fontWeight: "normal",
														color: theme.primaryTextColor,
													}}
												>
													₹
													{addCommas(
														isFromGoogle
															? calculations.TOTAL_AMOUNT
															: calculations.TOTAL_AMOUNT_WITH_SERVICE,
													)}
												</u>
											</div>
										</div>
										{/* {!calculations.discount_amount && (<PriceTool />)} */}
										{!isFromGoogle && calculations?.discount_amount && (
											<>
												<div className="con-space-between">
													<div
														className="text-sm-light"
														style={{
															display: "flex",
															alignItems: "center",
															gap: "8px",
															color: theme.primaryTextColor,
														}}
													>
														<CouponSvg />
														Coupon {`(${calculations?.coupon_code})`}
													</div>
													<div
														className="text-sm-bold"
														style={{
															color: "#11BF0E",
														}}
													>
														- ₹{addCommas(calculations?.discount_amount)}
													</div>
												</div>

												<hr />
											</>
										)}
										{currentUser?.isTravelAgent && (
											<div className=" ta-commission">
												<div className="con-space-between">
													<div
														style={{
															display: "flex",
															alignItems: "center",
															gap: "6.75px",
														}}
														// className="text-sm-light"
														// style={{ color: theme.primaryTextColor }}
													>
														<TaStars />
														Your Commission
													</div>
													<div
													// className="text-sm-bold"
													// style={{ color: theme.primaryTextColor }}
													>
														₹{addCommas(calculations.TA_COMMISSION)}
													</div>
												</div>
												<div
													style={{
														paddingTop: "5px",
														textAlign: "left",
														fontSize: "12px",
														display: "flex",
														flexDirection: "column",
													}}
												>
													<p>
														{calculations?.TA_COMMISSION === 0 &&
															"Your commission is 0, please make a booking with a larger amount for the commission"}
													</p>
													{/* <p style={{
														fontWeight:"700"
													}}>
														{calculations?.TA_COMMISSION === 0 &&
														calculations?.coupon_code?.includes("TAC") === false
															? "Add the TA coupon on the booking page"
															: null}
													</p> */}
												</div>
											</div>
										)}

										{!isFromGoogle && calculations?.discount_amount && (
											<div className="con-space-between">
												<div
													className="text-sm-light"
													style={{ color: theme.primaryTextColor }}
												>
													You Pay
												</div>
												<div
													className="text-sm-bold"
													style={{ color: theme.primaryTextColor }}
												>
													₹{addCommas(calculations.total_amount_with_discount)}
												</div>
											</div>
										)}
										{/* <StatusTag color={"#11BF0E"}>
						You are saving ₹{addCommas(2500)}
					</StatusTag> */}
									</>
								)}

							{/* {listingList?.new_home === 1 ? <NewHomeOffer /> : null} */}

							{/* {theme?.name !== "xseries" ? ( */}
							<button
								aria-label="Book Now"
								className="book-button-normal text-xsm font-heading spacing-1"
								onClick={() => {
									clevertap.event.push("proceed_to_payment", {
										listing_id: `${id ? id : newId}`,
										total_price: calculations.final_price,
										timestamp: new Date(),
									});
									dispatch({
										type: "FROM_BOOK_BUTTON",
										payload: true,
									});
									onCreateBooking();
								}}
								style={{
									background: theme?.bookingBtnBackground,
									color: theme?.bookingBtnTextColor,
								}}
								disabled={
									calLoading || calError || !dates.checkin || !dates.checkout
								}
							>
								{calLoading ? (
									<div
										style={{
											display: "flex",
											justifyContent: "center",
										}}
									>
										<Loader
											style={{
												width: "30px",
												height: "30px",
											}}
										/>
									</div>
								) : (
									"Book Now"
								)}
							</button>
							{/* ) : (
								<button
									onClick={() => {
										setAskOpen(true);
										clevertap.event.push("request_to_book_x-series", {
											listing_id: `${id ? id : newId}`,
											total_price: calculations.final_price,
											checkin: dates.checkin,
											checkout: dates.checkout,
											timestamp: new Date(),
										});
									}}
									className="book-button-normal text-xsm font-heading spacing-1"
									style={{
										background: theme?.bookingBtnBackground,
										color: theme?.bookingBtnTextColor,
									}}
								>
									<b>REQUEST TO BOOK</b>
								</button>
							)} */}
						</>
					) : (
						<button
							aria-label="book now"
							type="button"
							className="book-button-normal book-button text-xsm not-avail font-heading spacing-1"
							onClick={() => {
								setAskOpen(true);
							}}
						>
							Reserve Now
						</button>
					)}
					<AskMeModal
						open={askOpen}
						setOpen={setAskOpen}
						data={{
							theme: theme,
							LISTING_ID: listingList?.id,
							FROM_DATE:
								Object.keys(calculations).length > 0
									? calculations.FROM_DATE
									: "NA",
							TO_DATE:
								Object.keys(calculations).length > 0
									? calculations.TO_DATE
									: "NA",
							NO_OF_GUESTS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_GUESTS
									: listingList?.max_capacity,
							NO_OF_ROOMS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_ROOMS
									: listingList?.num_similar_rooms,
							TOTAL_AMOUNT_WITH_SERVICE:
								Object.keys(calculations).length > 0
									? calculations.TOTAL_AMOUNT_WITH_SERVICE
									: listingList?.per_night_charge,
							isListing: true,
							isReserveNow: roomOffer ? false : true,
							showLessRoom: roomOffer,
							allowSelectLessRoom: roomOffer,
						}}
					/>
					{!WeeklyOfferChecker(dates.checkin, dates.checkout) ? (
						theme?.name !== "xseries" &&
						Object.keys(calculations).length > 0 && (
							<p
								className=" clr-grey"
								style={{
									fontSize: "12px",
									background: calculations?.discount_amount && "#F3FEF3",
									borderRadius: "4px",
									padding: "4px 0",
								}}
							>
								{calculations?.discount_amount
									? "Coupon is applied when you book"
									: "You won't be charged yet"}
							</p>
						)
					) : (
						<p
							onClick={() => {
								setRoomOffer(true);
								setAskOpen(true);
							}}
							className=" clr-grey"
							style={{
								fontSize: "12px",
								background: calculations?.discount_amount && "#F3FEF3",
								borderRadius: "4px",
								padding: "4px 0",
							}}
						>
							Want to book fewer rooms?{" "}
							<span style={{ cursor: "pointer", textDecoration: "underline" }}>
								Click here
							</span>
						</p>
					)}
					{/* {newDates.checkin &&
						newDates.checkout &&
						prevCalculations?.room_charge - newCalculations?.room_charge >
							0 && (
							<ListingWeekDayOffer
								newDates={newDates}
								calculations={prevCalculations}
								newCalculations={newCalculations}
								dates={dates}
								setDates={setDates}
							/>
						)} */}
					{/*{dateDiff === 1 && prevCalculations?.discount_amount > 0 && (*/}
					{/*	<ListingWeekDayOffer*/}
					{/*		newDates={newDates}*/}
					{/*		newCalculations={prevCalculations}*/}
					{/*		dates={dates}*/}
					{/*		setDates={setDates}*/}
					{/*	/>*/}
					{/*)}*/}
					{/* {dateDiff === 2 && (
						<ListingWeekDayOfferGst dates={dates} setDates={setDates} />
					)} */}
				</div>
				{/* <Bookingfeature /> */}
				<AskHelp
					data={{
						theme: theme,
						LISTING_ID: listingList?.id,
						FROM_DATE:
							Object.keys(calculations).length > 0
								? calculations.FROM_DATE
								: "NA",
						TO_DATE:
							Object.keys(calculations).length > 0
								? calculations.TO_DATE
								: "NA",
						NO_OF_GUESTS:
							Object.keys(calculations).length > 0
								? calculations.NO_OF_GUESTS
								: listingList?.max_capacity,
						NO_OF_ROOMS:
							Object.keys(calculations).length > 0
								? calculations.NO_OF_ROOMS
								: listingList?.num_similar_rooms,
						TOTAL_AMOUNT_WITH_SERVICE:
							Object.keys(calculations).length > 0
								? calculations.TOTAL_AMOUNT_WITH_SERVICE
								: listingList?.per_night_charge,
						isListing: true,
						isVilla: listingList?.TYPE_FLAG === "MV",
						showLessRoom: listingList?.TYPE_FLAG === "EV",
					}}
				/>
				{/* <ListingPdf
					id={listingList?.id}
					villaName={listingList?.file_reference?.split("-")[0]}
				/> */}
				<div
					className="request-b2b"
					onClick={() => {
						// if (localStorage.getItem("token")) {
						// 	b2bLeadCreation();
						// } else {
						// 	setShouldShowModal(true);
						// }
						window.location.href = "/travelpartner?popup=true";
					}}
				>
					<p>Request B2B</p>
				</div>
			</div>

			<Modal shouldShow={showLeadFormModal} onRequestClose={closeLeadFormModal}>
				<LeadForm closeModal={closeLeadFormModal} listingID={newId || id} />
			</Modal>
			<Modal
				shouldShow={
					calError === "Mobile Number is missing" ||
					calError === "Email_id is missing" ||
					calError === "Please help us with your Name"
						? true
						: false
				}
				onRequestClose={undefined}
			>
				<FinishPhoneSignup
					userUUID={localStorage.getItem("uuid")}
					redirect={() => window.location.reload()}
				/>
			</Modal>
			<Modal
				shouldShow={shouldShowModal}
				onRequestClose={() => setShouldShowModal(true)}
			>
				{phone ? (
					<PhoneLoginHandler
						onRequestClose={() => setShouldShowModal(false)}
						setPhone={setPhone}
						// @ts-ignore
						phone={phone}
					/>
				) : (
					<EmailLoginHandler
						onRequestClose={() => setShouldShowModal(false)}
						setPhone={setPhone}
						phone={phone}
					/>
				)}
			</Modal>
			<ToastContainer />
		</>
	);
};

export default BookingBox;

const PriceTool = ({
	calculations,
	setIsShown,
	mealRequired,
	isShown,
	listingList,
}) => {
	const theme = useTheme();
	return renderToString(
		<div className="price-popup">
			<div className="price-header" style={{ color: theme.primaryTextColor }}>
				Price split
			</div>
			{Object.keys(calculations).length > 0 && (
				<div className="calculations ">
					<div className="con-space-between">
						<div className="text-xsm-light clr-grey">Room Charges</div>
						<div className="text-xsm clr-black">
							₹
							{addCommas(
								calculations.ROOM_CHARGES + calculations?.TOTAL_SERVICE_CHARGE,
							)}
						</div>
					</div>
					{calculations.MEAL_CHARGES ? (
						<div className="con-space-between">
							<div className="text-xsm-light clr-grey">Meals</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.MEAL_CHARGES)}
							</div>
						</div>
					) : null}
					{(calculations.EXTRA_CHARGES !== 0 ||
						calculations.TOTAL_BIG_CHILD_CHARGES !== 0) && (
						<div className="con-space-between">
							<div>
								<p className="text-xsm-light clr-grey">Extra Guest Charges</p>
								<span
									// onMouseEnter={() => setIsShown(true)}
									// onMouseLeave={() => setIsShown(false)}
									className="info-icon"
								>
									<SvgInfo />
									<div className="info-div">
										{`Any booking above ${
											listingList.min_rooms * 2
										} guest will be charged as extra guest.`}
									</div>
								</span>
							</div>
							<div className="text-xsm clr-black">
								₹
								{addCommas(
									calculations.EXTRA_CHARGES +
										calculations.TOTAL_BIG_CHILD_CHARGES,
								)}
							</div>
						</div>
					)}
					<div className="con-space-between">
						<div className="text-xsm-light clr-grey">GST</div>
						<div className="text-xsm clr-black">
							₹{addCommas(calculations.BOOKING_FEE_SERVICE_TAX_AMOUNT)}
						</div>
					</div>
					{calculations.PET_CHARGES !== 0 && (
						<div className="con-space-between">
							<div className="text-xsm-light clr-grey">Pet fee</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.PET_CHARGES)}
							</div>
						</div>
					)}
					{/* {calculations.SERVICE_CHARGE !== 0 && (
						<div className="con-space-between">
							<div className="text-xsm-light clr-grey">
								Convenience Fee (Incl 18% GST)
							</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.TOTAL_SERVICE_CHARGE)}
							</div>
						</div>
					)} */}
					{mealRequired && (
						<div className="con-space-between">
							<div className="text-xsm-light clr-grey">GST Meals</div>
							<div className="text-xsm clr-black">
								₹{addCommas(calculations.service_tax_meal)}
							</div>
						</div>
					)}
					<hr />
					<div className="con-space-between">
						<div className="text-sm-light">Total Price</div>
						<div className="text-sm-bold">
							₹{addCommas(calculations.TOTAL_AMOUNT_WITH_SERVICE)}
						</div>
					</div>
					{/* {calculations?.TOTAL_SERVICE_CHARGE === 0 && (
						<div className="con-space-between">
							<div className="convenience-text">
								<p>
									<Convenience /> Zero convenience fees on your booking
								</p>
							</div>
						</div>
					)} */}
				</div>
			)}
		</div>,
	);
};
